import { object, number, string } from "yup";

export interface MoneyResource {
  // value: number;
  currency: "PLN" | "EUR" | "USD" | "GBP";
  amount: string;
}

export const moneySchema = object().shape({
  // value: number().required(),
  currency: string().oneOf(["PLN", "EUR", "USD", "GBP"]).required(),
  amount: string().required(),
});
